const siteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

let scriptPromise;
let widgetId;
let activeTokenPromise;

export const isRecaptchaConfigured = () => Boolean(siteKey);

const loadRecaptcha = () => {
  if (!siteKey) return Promise.reject(new Error('reCAPTCHA is not configured.'));
  if (window.grecaptcha) return Promise.resolve(window.grecaptcha);
  if (scriptPromise) return scriptPromise;

  scriptPromise = new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = 'https://www.google.com/recaptcha/api.js?render=explicit';
    script.async = true;
    script.defer = true;
    script.onload = () => resolve(window.grecaptcha);
    script.onerror = () => reject(new Error('reCAPTCHA could not be loaded.'));
    document.head.appendChild(script);
  });

  return scriptPromise;
};

export const getRecaptchaToken = async () => {
  const recaptcha = await loadRecaptcha();
  if (!recaptcha?.render || !recaptcha?.execute) {
    throw new Error('reCAPTCHA could not be initialized.');
  }

  if (activeTokenPromise) return activeTokenPromise;

  activeTokenPromise = new Promise((resolve, reject) => {
    const complete = (token) => {
      activeTokenPromise = null;
      if (widgetId !== undefined) recaptcha.reset(widgetId);
      resolve(token);
    };
    const fail = () => {
      activeTokenPromise = null;
      reject(new Error('reCAPTCHA verification could not be completed.'));
    };

    if (widgetId === undefined) {
      const container = document.createElement('div');
      container.setAttribute('aria-hidden', 'true');
      document.body.appendChild(container);
      widgetId = recaptcha.render(container, {
        sitekey: siteKey,
        size: 'invisible',
        callback: complete,
        'expired-callback': fail,
        'error-callback': fail,
      });
    }

    recaptcha.execute(widgetId);
  });

  return activeTokenPromise;
};
